export default __webpack_public_path__ + "static/media/football480.ae29d510.jpg";